export const isEmpty = (value: unknown): boolean =>
    value === undefined || value === null || value === "";

export const getEventTag = (e: Event): HTMLUxIwsSearchTagElement | null =>
    (e.target as HTMLElement).closest<HTMLUxIwsSearchTagElement>(
        "ux-iws-search-tag"
    );

export const getEventTagGroup = (
    e: Event
): HTMLUxIwsSearchTagGroupElement | null =>
    (e.target as HTMLElement).closest<HTMLUxIwsSearchTagGroupElement>(
        "ux-iws-search-tag-group"
    );

export const findTags = (el: HTMLElement): HTMLUxIwsSearchTagElement[] =>
    Array.from(
        el.querySelectorAll<HTMLUxIwsSearchTagElement>("ux-iws-search-tag")
    );

export const findTagGroups = (
    el: HTMLElement
): HTMLUxIwsSearchTagGroupElement[] =>
    Array.from(
        el.querySelectorAll<HTMLUxIwsSearchTagGroupElement>(
            "ux-iws-search-tag-group"
        )
    );
